import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { api } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Restaurar sesión al iniciar
    useEffect(() => {
        const userStr = localStorage.getItem('user');
        const userId = localStorage.getItem('userId');

        if (userStr && userId) {
            try {
                const parsed = JSON.parse(userStr);
                setUser(parsed);
            } catch {
                localStorage.removeItem('user');
                localStorage.removeItem('userId');
                localStorage.removeItem('userEmail');
                localStorage.removeItem('userName');
                localStorage.removeItem('userRoot');
                localStorage.removeItem('userPhoto');
            }
        }
        setLoading(false);
    }, []);

    const login = useCallback(async (email, password) => {
        const res = await api.login(email, password);
        const data = res.data;

        if (data.success && data.user) {
            const user = data.user;
            const nombreCompleto = `${user.nombre || ''} ${user.apellido || ''}`.trim();

            localStorage.setItem('user', JSON.stringify(user));
            localStorage.setItem('userId', String(user.id));
            localStorage.setItem('userEmail', user.email || email);
            localStorage.setItem('userName', nombreCompleto || 'Usuario');
            localStorage.setItem('userRoot', Number(user.root) === 1 ? '1' : '0');
            localStorage.setItem('userPhoto', user.foto_perfil || '');

            setUser(user);
            return { success: true, user };
        }

        return { success: false, error: data.error || 'Error al iniciar sesión' };
    }, []);

    const logout = useCallback(() => {
        localStorage.clear();
        setUser(null);
    }, []);

    const isRoot = user?.root === 1 || localStorage.getItem('userRoot') === '1';

    const value = {
        user,
        setUser,           // ← Exportado para poder actualizar desde Configuracion
        isAuthenticated: !!user,
        isRoot,
        login,
        logout,
        loading,
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth debe usarse dentro de AuthProvider');
    }
    return context;
}